module.exports = __webpack_public_path__ + "static/media/blog-6.43f9f3e6.svg";